<template>
  <div class="error">
        <span class="aaa">404</span> <br><br><br><br><br><br>
        <span class="bbb">网站正在维护中...请稍后访问 </span>
    </div>      
</template>

<script>
export default {
methods:{
   
    
},

}
</script>

<style scoped>
 .error{
        text-align: center;
        margin-top: 25px;
        height: 600px;
    
      
    }
  .aaa{
              text-align: center;
        margin-top: 25px;
        height: 600px;
            font-size: 250px;
            color: black;
            font-family: '方正舒体'
        }
          .bbb{
   text-align: center;
        margin-top: 25px;
        height: 600px;
            font-size: 80px;
            color: black;
            font-family: '方正舒体'
        }
</style>


// WEBPACK FOOTER //
// src/components/Notfound.vue